/* chunq — global.js
   Vanilla JS only. Live clock, AJAX cart + drawer, product form, quantity steppers. */

(function () {
  'use strict';

  /* ---------- live clock ---------- */
  function startClocks() {
    var clocks = document.querySelectorAll('[data-clock]');
    if (!clocks.length) return;

    function tick() {
      clocks.forEach(function (el) {
        var tz = el.getAttribute('data-clock-tz') || 'America/New_York';
        var label = el.getAttribute('data-clock-label') || '';
        var now = new Date();
        var parts;
        try {
          parts = new Intl.DateTimeFormat('en-US', {
            timeZone: tz,
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true,
          }).formatToParts(now);
        } catch (e) {
          return;
        }
        var p = {};
        parts.forEach(function (part) {
          p[part.type] = part.value;
        });
        var ampm = (p.dayPeriod || '').toLowerCase();
        el.textContent =
          p.month + '/' + p.day + '/' + p.year + ' ' + p.hour + ':' + p.minute + ':' + p.second + ampm + (label ? ' ' + label : '');
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- countdown ---------- */
  function startCountdowns() {
    var els = document.querySelectorAll('[data-countdown]');
    if (!els.length) return;

    function pad(n) {
      return n < 10 ? '0' + n : '' + n;
    }

    function tick() {
      els.forEach(function (el) {
        var target = new Date(el.getAttribute('data-countdown')).getTime();
        if (isNaN(target)) return;
        var diff = target - Date.now();
        if (diff <= 0) {
          el.textContent = el.getAttribute('data-countdown-done') || '00:00:00';
          return;
        }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        el.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- cart helpers ---------- */
  function fetchJSON(url, options) {
    return fetch(url, options).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok) throw json;
        return json;
      });
    });
  }

  function updateCartCounts(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.toggleAttribute('data-cart-empty', cart.item_count === 0);
    });
  }

  function refreshDrawer(openAfter) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return Promise.resolve();
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (res) {
        return res.json();
      })
      .then(function (sections) {
        var html = sections['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('cart-drawer .drawer__panel');
        var current = drawer.querySelector('.drawer__panel');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        if (openAfter) drawer.open();
      })
      .catch(function () {});
  }

  window.chunqCart = {
    add: function (formData) {
      return fetchJSON('/cart/add.js', { method: 'POST', body: formData })
        .then(function () {
          return fetchJSON('/cart.js');
        })
        .then(function (cart) {
          updateCartCounts(cart);
          var drawer = document.querySelector('cart-drawer');
          if (drawer) {
            return refreshDrawer(true).then(function () {
              return cart;
            });
          }
          window.location.href = '/cart';
          return cart;
        });
    },
    change: function (line, quantity) {
      return fetchJSON('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity }),
      }).then(function (cart) {
        updateCartCounts(cart);
        return cart;
      });
    },
  };

  /* ---------- <product-form> ---------- */
  var ProductForm = (function () {
    function init(el) {
      var form = el.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      var button = form.querySelector('[data-add-button]');
      var errorBox = el.querySelector('[data-form-error]');

      form.addEventListener('submit', function (evt) {
        evt.preventDefault();
        if (button && button.disabled) return;
        var original = button ? button.textContent : '';
        if (button) {
          button.disabled = true;
          button.textContent = button.getAttribute('data-adding-text') || 'adding...';
        }
        if (errorBox) errorBox.hidden = true;

        window.chunqCart
          .add(new FormData(form))
          .then(function () {
            if (button) {
              button.textContent = button.getAttribute('data-added-text') || 'added';
              setTimeout(function () {
                button.disabled = false;
                button.textContent = original;
              }, 1200);
            }
          })
          .catch(function (err) {
            if (button) {
              button.disabled = false;
              button.textContent = original;
            }
            if (errorBox) {
              errorBox.textContent = (err && (err.description || err.message)) || 'could not add to cart';
              errorBox.hidden = false;
            }
          });
      });
    }
    return { init: init };
  })();

  /* ---------- <variant-selects> ----------
     Reads variant data from an embedded JSON script tag. On option change,
     finds the matching variant, updates price/availability/button/url. */
  var VariantSelects = (function () {
    function init(el) {
      var dataEl = el.querySelector('[data-variant-json]');
      var productEl = el.closest('[data-product]');
      if (!dataEl || !productEl) return;
      var variants;
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      var selects = el.querySelectorAll('[data-option-select]');
      var idInput = productEl.querySelector('input[name="id"]');
      var button = productEl.querySelector('[data-add-button]');
      var priceEl = productEl.querySelector('[data-product-price]');

      function currentOptions() {
        return Array.prototype.map.call(selects, function (s) {
          return s.value;
        });
      }

      function money(cents) {
        var format = window.chunqMoneyFormat || '${{amount}}';
        var amount = (cents / 100).toFixed(2);
        if (/amount_no_decimals/.test(format)) amount = Math.round(cents / 100).toString();
        if (/with_comma_separator/.test(format)) amount = amount.replace('.', ',');
        return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
      }

      function onChange() {
        var opts = currentOptions();
        var match = variants.find(function (v) {
          return v.options.every(function (opt, i) {
            return opt === opts[i];
          });
        });

        if (!match) {
          if (button) {
            button.disabled = true;
            button.textContent = 'unavailable';
          }
          return;
        }

        if (idInput) idInput.value = match.id;

        if (priceEl) priceEl.innerHTML = money(match.price);

        if (button) {
          if (match.available) {
            button.disabled = false;
            button.textContent = button.getAttribute('data-add-text') || 'add to cart';
          } else {
            button.disabled = true;
            button.textContent = 'sold out';
          }
        }

        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }

      selects.forEach(function (s) {
        s.addEventListener('change', onChange);
      });
      onChange();
    }
    return { init: init };
  })();

  /* ---------- <cart-drawer> ---------- */
  function defineDrawer() {
    if (customElements.get('cart-drawer')) return;

    class CartDrawer extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.addEventListener('click', function (evt) {
          if (evt.target.closest('[data-drawer-close]') || evt.target === self.querySelector('.drawer__scrim')) {
            self.close();
          }
          var lineBtn = evt.target.closest('[data-line-change]');
          if (lineBtn) {
            var line = parseInt(lineBtn.getAttribute('data-line'), 10);
            var qty = parseInt(lineBtn.getAttribute('data-quantity'), 10);
            window.chunqCart.change(line, qty).then(function () {
              refreshDrawer(true);
            });
          }
        });
        document.addEventListener('keydown', function (evt) {
          if (evt.key === 'Escape') self.close();
        });
      }
      open() {
        this.setAttribute('open', '');
        document.documentElement.style.overflow = 'hidden';
        var panel = this.querySelector('.drawer__panel');
        if (panel) panel.focus();
      }
      close() {
        this.removeAttribute('open');
        document.documentElement.style.overflow = '';
      }
    }
    customElements.define('cart-drawer', CartDrawer);
  }

  /* ---------- cart page quantity ---------- */
  function initCartPage() {
    var cartRoot = document.querySelector('[data-cart-page]');
    if (!cartRoot) return;

    cartRoot.addEventListener('click', function (evt) {
      var btn = evt.target.closest('[data-line-change]');
      if (!btn) return;
      evt.preventDefault();
      var line = parseInt(btn.getAttribute('data-line'), 10);
      var qty = parseInt(btn.getAttribute('data-quantity'), 10);
      window.chunqCart.change(line, qty).then(function () {
        window.location.reload();
      });
    });
  }

  /* ---------- header cart icon opens drawer ---------- */
  function initCartLink() {
    document.addEventListener('click', function (evt) {
      var link = evt.target.closest('[data-cart-open]');
      if (!link) return;
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      evt.preventDefault();
      refreshDrawer(true);
    });
  }

  /* ---------- boot ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    startClocks();
    startCountdowns();
    defineDrawer();
    initCartPage();
    initCartLink();
    document.querySelectorAll('[data-product-form]').forEach(ProductForm.init);
    document.querySelectorAll('[data-variant-selects]').forEach(VariantSelects.init);
  });
})();
